export const pt = {
    logout: `Sair`,
    changePassword: `Alterar senha`,
    editProfile: `Editar perfil`,
    theme: `Tema`,
    language: `Idioma`,
};
//# sourceMappingURL=pt.js.map